export const PARENT_N_CHILD_POLYGONS = [
  { parentId: 1968, childsIds: [220908, 220902, 220909, 107222, 220903, 220907, 107223, 220906] },
  { parentId: 1937, childsIds: [107530, 220910] },
  { parentId: 1944, childsIds: [107228, 203617] },
  { parentId: 1943, childsIds: [125193, 76409] },
  { parentId: 1972, childsIds: [186636, 107534] },
  { parentId: 1919, childsIds: [147847, 107524, 1918] },
];

export const MAIN_POLYGONS = [1964, 1999, 1959, 2003, 2000];
